export default __webpack_public_path__ + "static/media/precise-location-selected-focused.5e551a08.svg";